module.exports = {
  flexDirection: { value: 'column' },
  input: {
    textAlign: { value: 'center' },
  },
};
